/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index slider to autogenerate all the components and extensions
 * Used by "prepareSliders"
 */

import Slider from './slider/Slider'
export * from './slider/Slider'
export default Slider
